import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import HistoricalFlightHeader from './children/HistoricalFlightHeader/HistoricalFlightHeader';
import HistoricalFlightInformation from './children/HistoricalFlightInformation/HistoricalFlightInformation';
import componentBase from '../../../../../../src/lib/component-base';
import { addMetaCanonical } from '../../../../../../shared/lib/meta-tags';

@componentBase('HistoricalFlightTracker')
export default class HistoricalFlightTracker extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    error: PropTypes.object,
    hasCredits: PropTypes.bool,
    match: PropTypes.object,
    details: PropTypes.object,
    style: PropTypes.object,
    extendedDetails: PropTypes.bool,
    extendedDetailsAds: PropTypes.array,
    segments: PropTypes.array,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.logger('Refresh error:', nextProps.error);
    }
  }

  metaTags = (flight) => {
    const flightString = `(${flight.carrier.fs}) ${flight.carrier.name} #${flight.carrier.flightNumber}`;
    const title = `${flightString} ${this.props.extendedDetails ? 'Flight Details' : 'Historical Flight Status'}`;
    const description = `${this.props.extendedDetails ? 'Flight details' : 'Historical flight status'} for flight ${flightString}`;
    const keywords = `${flight.carrier.fs} ${flight.carrier.flightNumber} ${this.props.extendedDetails ? 'flight details' : 'historical flight status'}, ${flight.carrier.name} ${flight.carrier.flightNumber} ${this.props.extendedDetails ? 'flight details' : 'historical flight status'}`;

    const metaWithoutCanonical = {
      title,
      meta: [
        { name: 'description', content: description },
        { name: 'keywords', content: keywords },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
      ],
    };

    const meta = addMetaCanonical(metaWithoutCanonical, flight.url);
    return meta;
  };

  render() {
    let results = '';

    const {
      details,
      dispatch,
      extendedDetailsAds,
      extendedDetails,
      hasCredits,
      match,
      segments,
    } = this.props;

    if (details) {
      this.selectedRouteIndex = 0;
      const params = match && match.params;
      const flight = details.details || details;
      if (segments) {
        this.selectedRouteIndex = segments.findIndex((segment) => {
          if (`${segment.flightId}` === `${params && params.flightId}` ||
              `${segment.flightId}` === `${flight.flightId}`) {
            return true;
          }
          return false;
        });
      }

      flight.uplines = [];
      flight.downlines = [];

      segments && segments.forEach((segment, i) => {
        if (i < this.selectedRouteIndex) {
          flight.uplines.push(segment.lineInfo);
        } else if (i > this.selectedRouteIndex) {
          flight.downlines.push(segment.lineInfo);
        }
      });

      if (flight) {
        const meta = this.metaTags(flight);
        const props = {
          ...flight,
          ...{ hasCredits },
          extendedDetails,
          extendedDetailsAds,
          dispatch,
          match,
        };

        results = (
          <section>
            <Helmet {...meta} />
            <HistoricalFlightHeader {...flight} extendedDetails={extendedDetails} />
            <HistoricalFlightInformation {...props} />
          </section>
        );
      }
    }

    return (
      <div style={this.props.style}>
        {results}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HistoricalFlightStatus/components/HistoricalFlightTracker/children/FlightTracker/HistoricalFlightTracker.js